import { z } from "zod";
import { isValidCNPJ, normalizeDocument } from "@cx/domain";

/** Certificado digital A1 (T2.1, RF-PRF-08) e notificações do sino. */

/** Situação do cadastro do certificado no provedor fiscal externo (Nuvem Fiscal na T2.3; sandbox antes). */
export const CERTIFICATE_PROVIDER_STATUS = ["pending", "registered", "failed", "disabled"] as const;
export type CertificateProviderStatus = (typeof CERTIFICATE_PROVIDER_STATUS)[number];
/** Provedor fiscal configurado no Worker (`FISCAL_PROVIDER`). */
export type FiscalProviderId = "sandbox" | "nuvemfiscal" | "disabled";

/** Certificado como a API mostra: nunca o arquivo nem a senha. Datas ISO (instantes). */
export type CertificateView = {
  id: string;
  subjectName: string;
  subjectCnpj: string;
  issuerName: string;
  serialNumber: string;
  thumbprintSha1: string;
  fingerprintSha256: string;
  validFrom: string;
  validTo: string;
  sizeBytes: number;
  active: boolean;
  replacedAt: string | null;
  providerStatus: CertificateProviderStatus;
  providerError: string | null;
  providerSyncedAt: string | null;
  createdAt: string;
};

export type FiscalCertificateResponse = {
  company: { legalName: string; cnpj: string | null };
  current: CertificateView | null;
  /** Substituídos, do mais recente ao mais antigo (até 20). */
  history: CertificateView[];
  provider: FiscalProviderId;
};

export const companyCnpjInput = z.object({
  cnpj: z
    .string()
    .trim()
    .max(20, "CNPJ inválido")
    .refine((v) => isValidCNPJ(v), "CNPJ inválido")
    .transform((v) => normalizeDocument(v)),
});
export type CompanyCnpjInput = z.infer<typeof companyCnpjInput>;

/** Senha do .pfx: como digitada (espaços contam). */
export const certificatePassword = z
  .string()
  .min(1, "Informe a senha do certificado")
  .max(128, "Senha com até 128 caracteres");

export type NotificationSeverity = "info" | "warning" | "danger";
export type NotificationView = {
  id: string;
  kind: string;
  severity: NotificationSeverity;
  title: string;
  body: string;
  link: string | null;
  createdAt: string;
  read: boolean;
};
export type NotificationList = { data: NotificationView[]; unread: number };

export const notificationListQuery = z.object({ unread: z.stringbool().default(false) });
